import types from '../actiontypes'

export const AddLayoutBreadCrumbKey = (key, value, disabled) => {
  return {
    type: types.Layout.AddBreadCrumbKey,
    payload: {
      key,
      value,
      disabled: disabled === true
    }
  }
}

export const AddLayoutBreadCrumbKeyDispatch = (dispatch) => {
  return (key, value, disabled) => {
    dispatch(AddLayoutBreadCrumbKey(key, value, disabled))
  }
}

export const ClearLayoutBreadCrumbKeys = () => {
  return {
    type: types.Layout.ClearBreadCrumbKeys
  }
}

export const ClearLayoutBreadCrumbKeysDispatch = (dispatch) => {
  return () => {
    dispatch(ClearLayoutBreadCrumbKeys())
  }
}
